var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.7,35.1C17.7,35.1,17.7,35.1,17.7,35.1c0.6,0,1-0.5,1-1L18,20.1c0-0.6-0.5-1-1-0.9c-0.6,0-1,0.5-0.9,1l0.7,13.9   C16.7,34.6,17.2,35.1,17.7,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9,35.1C30,35.1,30,35.1,29.9,35.1c0.6,0,1-0.4,1-0.9l0.7-13.9c0-0.6-0.4-1-0.9-1c-0.6,0-1,0.4-1,0.9L29,34   C29,34.6,29.4,35,29.9,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,35.1c0.6,0,1-0.4,1-1V20.1c0-0.6-0.4-1-1-1s-1,0.4-1,1v13.9C23,34.6,23.4,35.1,24,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,11.6H10.7l-0.7,0c0,0,0,0,0,0c0,0,0,0,0,0H7c-0.6,0-1,0.4-1,1s0.4,1,1,1h2.1l2.3,23.9c0.2,2.6,2.4,4.6,4.9,4.6h15   c2.6,0,4.7-2,4.9-4.6l2.3-23.9H41c0.6,0,1-0.4,1-1S41.6,11.6,41,11.6z M34.3,37.3c-0.1,1.6-1.4,2.7-2.9,2.7h-15   c-1.5,0-2.8-1.2-2.9-2.7l-2.2-23.7l25.4,0L34.3,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,8h11.3c0.6,0,1-0.4,1-1s-0.4-1-1-1H18.6c-0.6,0-1,0.4-1,1S18,8,18.6,8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.dd9ce7c2cd2ff7e046f4fec4fc94922a.svg";
export { ForwardRef as ReactComponent };